/**
 * License API
 *
 * @author shahrukh@virtualemployee.com
*/
import httpService from '@/api/httpService'
const licenseApi = {

    // member license details
    getMemberLicenseDetails(params) {
        return httpService.get('/license/member', params);
    },

    // getEnrolmentGuiidance
    getEnrolmentGuidance(params) {
        return httpService.get('/license/responsibility/file', params);
    },

    // getLicense
    getLicenseResponsibility(params) {
        return httpService.get('/license/responsibility/member',params);
    },

    // addLicense
    addLicense(params) {
        return httpService.post('/license/member', params);
    },

    // updateLicense
    updateLicense(id, params) {
        return httpService.put('/license/member/'+id , params);
    },

    // deleteLicense
    deleteLicense(id) {
        return httpService.delete('/license/member/' + id);
    } 
}

export default licenseApi;
